export default __webpack_public_path__ + "static/media/optimal-body-therapy-kit.d9729f87.webp";